var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Has Commission Statement Been Ordered?"}},[_c('input-radio-boolean',{attrs:{"name":"ordered_commission_statement","value":_vm.closing.ordered_commission_statement,"true":"Yes","false":"No","read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }